export const REFERRAL_INVITE_LAYOUT_PARAMS = {
  showClaimReferralModal: 'showClaimReferralModal',
}
